export type SchedulingMode = 'queue' | 'dedicated';

/**
 * Lead info without a scheduled call (e.g. no Salesforce opportunity yet) omits
 * schedulingMode entirely — treated the same as 'dedicated', matching CM's own
 * default when a scheduled call exists but isn't queue-based. The API key is
 * the same regardless of schedulingMode; only the entry id differs.
 */
export function getZoomEntryId(schedulingMode?: SchedulingMode): string {
  const queueBasedCallingDisabled = process.env.REACT_APP_DISABLE_QUEUE_BASED_CALLING === 'true';

  if (schedulingMode === 'queue' && !queueBasedCallingDisabled) {
    return process.env.REACT_APP_ZOOM_QUEUE_BASED_VIDEO_FLOW_ENTRY_ID || '';
  }

  return process.env.REACT_APP_ZOOM_ENTRY_ID || '';
}
